<template>
    <el-form :model="modelValue" ref="formRef" :rules="readonly ? {} : rules" label-width="100px" size="small"
        :class="readonly ? 'smith-form' : ''">
        <el-row :gutter="24">
            <el-col :span="readonly ? 8 : 24">
                <el-form-item label="Name" prop="name">
                    <el-input v-model="modelValue.name" :readonly="readonly" style="width: 100%" />
                </el-form-item>
                <el-form-item label="Name Code" prop="nameCode">
                    <el-input v-model="modelValue.nameCode" :readonly="readonly" style="width: 100%" />
                </el-form-item>
                <el-form-item v-if="readonly" label="Username">
                    <el-input v-model="modelValue.username" readonly style="width: 100%" />
                </el-form-item>
                <el-form-item label="Email" prop="email">
                    <el-input v-model="modelValue.email" :readonly="readonly" style="width: 100%" />
                </el-form-item>
            </el-col>

            <el-col :span="readonly ? 8 : 24">
                <el-form-item label="Phone" prop="phone">
                    <el-input v-model="modelValue.phone" :readonly="readonly" style="width: 100%" />
                </el-form-item>
                <el-form-item label="Address" prop="address">
                    <el-input v-model="modelValue.address" :readonly="readonly" style="width: 100%" />
                </el-form-item>
                <el-form-item label="Remark" prop="remark">
                    <el-input v-model="modelValue.remark" type="textarea" :rows="5" :readonly="readonly"
                        style="width: 100%" />
                </el-form-item>
                <el-form-item label="Status" prop="status">
                    <el-tag v-if="readonly" :type="modelValue.status === 1 ? 'success' : 'danger'">
                        {{ modelValue.status === 1 ? 'Active' : 'Inactive' }}
                    </el-tag>
                    <el-radio-group v-else v-model="modelValue.status">
                        <el-radio :label="1">Active</el-radio>
                        <el-radio :label="0">Disabled</el-radio>
                    </el-radio-group>
                </el-form-item>
            </el-col>
        </el-row>
    </el-form>
</template>

<script setup>
import { ref } from 'vue'

const props = defineProps({
    modelValue: { type: Object, required: true },
    readonly: { type: Boolean, default: true },
})

const rules = {
    name: [{ required: true, message: 'This field is required', trigger: 'blur' }],
    nameCode: [{ required: true, message: 'This field is required', trigger: 'blur' }],
    phone: [{ required: true, message: 'This field is required', trigger: 'blur' }],
}

const formRef = ref(null)

defineExpose({
    validate: () => formRef.value?.validate(),
    resetFields: () => formRef.value?.resetFields(),
    clearValidate: () => formRef.value?.clearValidate(),
})
</script>

<style scoped>
.smith-form {
    /* background: #fafafa; */
    padding: 20px;
    border-radius: 8px;
}
</style>
